export * from "./customMaterial.js";
export * from "./pbrCustomMaterial.js";
//# sourceMappingURL=index.js.map